<template>
  <div v-if="
  this.enableSearch === true &&
  this.licenceOK === true &&
  this.userOK === true &&
  this.enableAccessAuthSearch(this.data.tag) === true
  ">
    <v-layout class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.btnColor" flat dark>
        <v-icon left>
          search
        </v-icon>
        search
      </v-btn>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="title wplblue1--text">
            {{searchObj.title}}
            <v-spacer/>
            <v-chip :color="ui.bkgdColorSecondary" :class="ui.textSubheading"
            v-if="this.getSearchResults !== null && this.searchObj.enableCtr">
              <v-avatar>
              <v-icon> playlist_add </v-icon>
              </v-avatar>
              {{this.getSearchResults.length}}
            </v-chip>
          </v-card-title>
          <v-layout row class="ml-3 mr-4"
          v-if="
          this.getOrgDetailBasic !== null &&
          this.getOrgDetailBasic !== undefined
          ">
            <div :class="ui.textSubheadingBold">
              {{getOrgDetailBasic.id}} {{getOrgDetailBasic.title}}
            </div>
            <v-spacer/>
            <div :class="ui.textSubheadingBold">
              {{displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg)}}
            </div>
          </v-layout>
          <v-progress-linear :color="ui.btnColor" height="1" value="100">
          </v-progress-linear>
          <!-- {{this.search}} -->
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.title"
                    label="search title"
                    :prepend-icon="searchObj.icon"
                    @keyup.enter="validate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="this.data.tag !== 'C1' && this.data.tag !== 'F1'">
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.id"
                    label="search id or tag"
                    prepend-icon="fingerprint"
                    @keyup.enter="validate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="this.enableFacilityNameSearchFromCompany">
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.ft"
                    label="facility name"
                    prepend-icon="place"
                    @keyup.enter="validate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout  row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-btn :color="ui.btnColorBkgd" icon
              v-if="this.search.enableFacilityOnly">
                <v-icon :color="ui.btnColor"> place </v-icon>
              </v-btn>
              <v-btn :color="ui.colorBlue" flat dark
              class="hidden-xs-only"
              v-if="this.getSearchResults !== null && this.searchObj.enableCtr">
                <v-icon left :color="ui.colorBlue"> manage_search </v-icon>
                {{this.getUser.pref.search.limit}}
              </v-btn>
              <v-spacer/>
              <div v-if="enableSpinBtnSearch === false">
                <v-btn :disabled="searchDisable" :color="ui.btnColor"
                  @click="validate" flat>
                  <v-icon left> search </v-icon>
                    search
                </v-btn>
              </div>
              <div v-else>
                <BtnSpin :btnSpec="btnInfo1"/>
              </div>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import search from "@/data/search/mixins/search.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
export default {
  // eslint-disable-next-line
  mixins: [
    search,
    apptheme,
    dataSources,
    accessFunctions,
    displayFunctions,
    describeDocument,
    licenceFunctions,
    adminFunctions,
    registerFunctions
  ],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getProcedure",
      "getCurrentPage",
      "getSearchResults",
      "getOrgDetailBasic",
      "getRegisterInfo"
    ]),
    enableSearch() {
      let logic = false;
      if (this.data.tag === "C1") {
        logic = true;
      } else if (
        // eslint-disable-next-line
        this.enableAccessAuthView(this.data.tag, this.getUser.pref.select.cauth) ||
        this.enableAccessAuthView(this.data.tag, this.getUser.pref.select.fauth)
      ) {
        logic = true;
      } else {
        logic = true;
      }
      return logic;
    },
    enableFacilityNameSearchFromCompany() {
      let logic = false;
      if (this.data.tag !== null && this.searchArchive === true) {
        logic = false;
      } else if (this.enableFacilityOnlySearch === false) {
        if (
          this.data.tag === "B1" ||
          this.data.tag === "B3" ||
          this.data.tag === "B4" ||
          this.data.tag === "B6" ||
          this.data.tag === "E1" ||
          this.data.tag === "E2" ||
          this.data.tag === "E6" ||
          this.data.tag === "L1" ||
          this.data.tag === "M2" ||
          this.data.tag === "S1" ||
          this.data.tag === "S6" ||
          this.data.tag === "W6"
        ) {
          logic = true;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    enableFacilityOnlySearch() {
      let logic = false;
      if (this.data.tag !== null && this.searchArchive === true) {
        logic = false;
      } else if (
        this.data.tag === "A1" ||
        this.data.tag === "O1" ||
        this.data.tag === "M5" ||
        this.data.tag === "W1" ||
        this.data.tag === "W2"
      ) {
        logic = false;
      } else if (this.data.reach === "facility") {
        logic = true;
      } else if (
        this.getRegisterInfo !== null &&
        this.getRegisterInfo.tag === "F1"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    searchDisable() {
      if (this.search.title !== "" || this.search.id !== "") {
        return false;
      } else {
        return true;
      }
    },
    searchArchive() {
      let logic = null;
      if (
        this.getSearchResults !== null &&
        this.getSearchResults !== undefined &&
        this.getSearchResults.length > 0
      ) {
        let arch = this.getSearchResults[0].basic.ver;
        if (arch === "A") {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    searchObj() {
      let obj = {
        title: "Search",
        icon: "",
        enableIdSearch: true,
        enableCtr: false
      };
      let tag = null;
      if (
        this.getSearchResults !== null &&
        this.getSearchResults !== undefined &&
        this.getSearchResults.length > 0
      ) {
        tag = this.getSearchResults[0].basic.tag;
        if (tag !== null && this.searchArchive === true) {
          obj.title = "Search Archives";
          obj.icon = "archive";
        } else if (tag !== "G1") {
          // NOT ACCESS SEARCH
          obj.title = "Search " + this.defineDocumentFromTag(tag).title;
          obj.icon = this.defineDocumentFromTag(this.data.tag).icon;
          obj.enableCtr = true;
          if (this.enableFacilityOnlySearch === true) {
            obj.title = "Facility " + this.defineDocumentFromTag(tag).title;
          }
          if (this.data.tag === "C1") {
            obj.enableIdSearch = false;
          }
        } else {
          obj.title = this.data.title;
          obj.icon = this.defineDocumentFromTag(this.data.tag).icon;
        }
      } else {
        obj.title = this.data.title;
        let tagLoc = this.data.tag;
        if (this.enableFacilityOnlySearch === true) {
          obj.title = "Facility " + this.defineDocumentFromTag(tagLoc).title;
        }
        obj.icon = this.defineDocumentFromTag(this.data.tag).icon;
      }
      return obj;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinBtnSearch: false,
      search: {
        tag: "", // tag
        id: "", // id for search
        arch: "",
        title: "", // title for search
        ft: "", // facility title
        enableFt: false, // genable facility title search (generic)
        enableFacilityOnly: false, // emebedded list like f2
        dbs: "" // data base source
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  },
  methods: {
    openDialog() {
      console.log("");
      console.log("OPENED SEARCH TAG");
      console.log(this.data);
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      if (this.data.tag !== undefined) {
        this.search.tag = this.data.tag;
      }

      // CHECK if FACILITY SEARCH is enabled
      this.search.enableFt = false;
      if (
        this.enableFacilityOnlySearch === true ||
        this.enableFacilityNameSearchFromCompany === true
      ) {
        this.search.enableFt = true;
        // CHECK REGISTER
        if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "U1"
        ) {
          // no change
        } else {
          // change to company
          let select = this.getUser.pref.select;
          let reg = this.generateRegisterInfoCompanyListFromUser(select);
          this.$store.dispatch("changeRegisterInfo", reg);
        }

        // define search
        if (this.enableFacilityOnlySearch === true) {
          this.search.ft = this.getUser.pref.select.fname;
          this.search.enableFacilityOnly = true;
          // CHANGE REGISTER TO PREPARE FOR SEARCH
          let select = this.getUser.pref.select;
          let reg = this.generateRegisterInfoFacilityListFromUser(select);
          this.$store.dispatch("changeRegisterInfo", reg);
        }
      }
      // DEFINE DATA SOURCE
      // DEFINE DB
      let db = null;
      // eslint-disable-next-line
      if (this.searchArchive === true) {
        db = this.defineDataSourceFromTagForArchive(this.data.tag);
      } else if (this.data.tag === "C1") {
        db = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "F1") {
        db = this.defineDataSourceFromTag(this.data.tag);
      } else if (
        this.getRegisterInfo !== undefined &&
        this.getRegisterInfo !== null
      ) {
        let embeddedTag = this.getRegisterInfo.tag;
        if (this.getRegisterInfo.tag === "U1") {
          embeddedTag = "U1.B3";
          console.log("ACTION");
        }
        if (this.getRegisterInfo.tag === "C1") {
          embeddedTag = this.data.tag;
          console.log("COMPANY REGISTER");
          console.log(embeddedTag);
        }
        if (this.getRegisterInfo.tag === "F1") {
          if (
            this.getSearchResults !== null &&
            this.getSearchResults !== undefined
          ) {
            embeddedTag = this.getSearchResults[0].basic.tag;
          } else {
            embeddedTag = "F1";
          }
        }
        if (this.getRegisterInfo.tag === "B6") {
          embeddedTag = "B6.W";
        }
        if (this.getRegisterInfo.tag === "B4") {
          embeddedTag = "B4.Q1";
        }
        if (this.getRegisterInfo.tag === "M2") {
          embeddedTag = "M2.M5";
        }
        if (this.getRegisterInfo.tag === "M5") {
          embeddedTag = "M7";
        }
        // console.log("EMBEDDED TAG");
        // console.log(embeddedTag);
        db = this.defineDataSourceFromTag(embeddedTag);
      } else {
        // console.log("NOT EMBEDDED TAG");
        db = this.defineDataSourceFromTag(this.data.tag);
      }
      // DATABASE ASSIGN
      this.search.dbs = db;

      // console.log("");
      // console.log(">>> SEARCH OPENED <<<");
      // console.log("TAG :              " + this.data.tag);
      // console.log("ARCHIVE :          " + this.searchArchive);
      // console.log("DBS :              " + this.search.dbs);
      // console.log("Facility Search:   " + this.search.enableFt);
      // console.log("Facility Only:     " + this.search.enableFacilityOnly);
      // console.log("Facility Title:    " + this.getUser.pref.select.fname);
      // console.log(this.search);
    },
    closeDialog() {
      this.dialog = false;
      // this.$store.dispatch("changeDataReach", "");
      // this.$store.dispatch("changeDataSource", "");
    },
    validate() {
      if (this.$refs.form.validate() === true) {
        this.enableSpinBtnSearch = true;
        this.searchDocuments(this.search);
      }
    }
  }
};
</script>
